var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiSkillsPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 2L10.3 6.7C10.5 7.4 11 7.9 11.7 8.1L16.5 9.5L11.7 10.9C11 11.1 10.5 11.6 10.3 12.3L9 17L7.7 12.3C7.5 11.6 7 11.1 6.3 10.9L1.5 9.5L6.3 8.1C7 7.9 7.5 7.4 7.7 6.7L9 2Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12L17.7 14.3C17.8 14.6 18 14.8 18.3 14.9L20.5 15.5L18.3 16.1C18 16.2 17.8 16.4 17.7 16.7L17 19L16.3 16.7C16.2 16.4 16 16.2 15.7 16.1L13.5 15.5L15.7 14.9C16 14.8 16.2 14.6 16.3 14.3L17 12Z",
    stroke: "currentColor",
    strokeWidth: 1,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiSkillsPractice);
export default __webpack_public_path__ + "static/media/ai-skills-practice.7659b714d2a1321083fb144f8c958d6c.svg";
export { ForwardRef as ReactComponent };